"use client";
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "@/components/ui/sheet";
import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
} from "@/components/ui/drawer";
import { useIsMobile } from "@/hooks/use-mobile";
import * as icon from "@tabler/icons-react";
import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuItem,
    SidebarSeparator,
    useSidebar,
} from "@/components/ui/sidebar";
import React from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
interface Props {
    id?: string;
    children: React.ReactNode;
    icon?: React.ReactNode;
    title: string;
    subTitle?: string;
    description?: string;
    trigger?: React.ReactNode;
    footer?: React.ReactNode;
    options?: React.ReactNode;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    side?: "left" | "right";
    absolute?: boolean | undefined;
    collapsible?: "icon" | "offcanvas" | "none" | undefined;
    fullHeight?: boolean;
    transparentOverlay?: boolean;
    addBorder?: boolean;
    className?: string;
}

export default function SidebarDrawer({
    id,
    children,
    icon,
    title,
    subTitle,
    description,
    trigger,
    footer,
    options,
    open,
    side,
    absolute,
    collapsible,
    onOpenChange,
    fullHeight,
    transparentOverlay = true,
    addBorder,
    className,
}: Props) {
    const isMobile = useIsMobile();
    const snapPoints = [0.2, 0.5];
    const [snap, setSnap] = React.useState<number | string | null>(
        snapPoints[0]
    );

    if (isMobile) {
        return (
            <Drawer
                open={open}
                onOpenChange={onOpenChange}
                defaultOpen={false}
                key={id}
                // snapPoints={snapPoints}
                // activeSnapPoint={snap}
                // setActiveSnapPoint={setSnap}

                // snapPoints={snapPoints}
            >
                {/* <DrawerTrigger asChild>{trigger}</DrawerTrigger> */}
                <DrawerContent
                    className={cn(
                        "z-[999] max-h-[60%] px-4",
                        fullHeight && "h-full min-h-[60%]"
                    )}
                    transparentOverlay={transparentOverlay}
                >
                    <DrawerHeader className={cn("px-0 pb-2 pt-0")}>
                        <div className="flex items-center justify-between">
                            {title && <DrawerTitle>{title}</DrawerTitle>}
                            <div className="z-[9999] flex items-center">
                                {options && options}
                            </div>
                        </div>
                    </DrawerHeader>
                    <div
                        className={cn(
                            "h-full overflow-auto"
                            // snap === 0.5 && "overflow-y-auto",
                            // snap !== 0.5 && "overflow-hidden"
                        )}
                    >
                        {children}
                        {footer && <DrawerFooter>{footer}</DrawerFooter>}
                    </div>
                </DrawerContent>
            </Drawer>
        );
    }

    return (
        <Sidebar
            side={side ? side : "left"}
            variant={"floating"}
            absolute
            collapsible={collapsible ? collapsible : "offcanvas"}
            className="top-0 z-20 mb-0"
            subClassName={cn(
                "bg-card h-fit max-h-full",
                !children && "hidden",
                className
            )}

            // key={id}
        >
            <SidebarHeader className={cn("", addBorder && "border-b p-2")}>
                <SidebarMenu key={id}>
                    <SidebarMenuItem className="flex items-center justify-between">
                        <div className="flex flex-col">
                            <Label variant={"toggle"}>{title}</Label>
                            <Label variant={"subtoggle"}>{description}</Label>
                        </div>
                        <div className="flex items-center">
                            {options && options}
                        </div>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarHeader>
            <SidebarContent key={id} className={cn(addBorder && "pt-2")}>
                <SidebarGroup>
                    {/* <SidebarGroupLabel className="sticky top-0 text-base font-bold">
                        {title}
                    </SidebarGroupLabel> */}
                    <SidebarGroupContent key={id}>
                        {children}
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    );
}
